import axios from "axios";
import qs from 'qs';
import {showMessage} from "./notice";
import {Loading} from "element-ui";
import {getStore, setStore} from "./storage";

const request = axios.create({
  baseURL: "/sms",
  timeout: 10000,
})

/**
 * config.target：响应数据的dom容器，在请求完成前，用loading遮罩
 */
request.interceptors.request.use(
  config => {
    if (config.target) {
      config.loading = Loading.service({target: config.target, customClass: "sms-loading"});
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)
/**
 * 1.200：
 * success为true：请求成功
 * success为false：请求失败，返回的均是可读信息（根据此信息可以快速定位）
 *
 * 2.401：
 * errorType为NOT_LOGIN_LOCAL：未进行本地登录，跳转到本地登录界面
 * errorType为NOT_LOGIN_CAS：CAS校验不通过，跳转到CAS登录界面
 *
 * 3.其他：（例如400，404，500，502，504等）
 * 均显示为未知错误
 */
request.interceptors.response.use(
  response => {
    if (response.config.loading) {
      response.config.loading.close()
    }
    if (response.data.success) {
      return Promise.resolve(response.data);
    } else {
      showMessage("请求失败，异常信息：" + response.data.reason, "error")
      return Promise.reject()
    }
  },
  error => {
    if (error.config.loading) {
      error.config.loading.close()
    }
    let status = error.response.status;
    let data = error.response.data;

    if (status === 401) {
      if (data.errorType) {
        switch (data.errorType) {
          case "NOT_LOGIN_CAS":
            //将当前的location记录下来，等到登录成功后，再跳转回来
            setStore("casReferer", location.origin + location.pathname);
            location.href = process.env.smsCasLoginUrl
            break;
        }
      }
    } else {
      showMessage("未知错误，请联系管理员", "error")
    }
    //无论何种场景，打断请求
    return Promise.reject(error)
  }
)

/**
 * 全局get请求
 * @param {*} url
 * @param {*} params
 * @param target 在请求完成前，显示loading动画的dom元素
 */
export const getRequestSms = (url, params, target) => {
  let tokenId = getStore("smsTokenId");
  if (tokenId) {
    params.tokenid = tokenId;
  }
  let headers = {
    "request-source": "sms-repo-web"
  };
  return request({
    method: 'get',
    url,
    params,
    headers,
    paramsSerializer(params) {
      return qs.stringify(params, {arrayFormat: 'repeat'})
    },
    target: target
  });
}
/**
 * 全局post请求
 * @param {*} url
 * @param {*} params
 * @param target 在请求完成前，显示loading动画的dom元素
 */
export const postRequestSms = (url, params, target) => {
  let headers = {
    "content-type": "application/x-www-form-urlencoded",
    "request-source": "sms-repo-web",
  };
  let tokenId = getStore("smsTokenId");
  if (tokenId) {
    params.tokenid = tokenId;
  }
  return request({
    method: 'post',
    url,
    //sms的后台参数都是通过request.getParameter方式获取的，所以采用x-www-form-urlencoded + qs序列化参数方式请求
    headers: headers,
    data: qs.stringify(params),
    target: target
  });
}

/**
 * 多部分Post请求
 * @param url
 * @param params
 * @param form FormData
 * @returns {*}
 */
export const postMultiPartRequestSms = (url, params, form) => {
  let tokenId = getStore("smsTokenId");
  if (tokenId) {
    params.tokenid = tokenId;
  }

  let headers = {
    "content-type": "multipart/form-data",
  };

  if (params) url += "&" + qs.stringify(params);

  return request({
    method: 'post',
    url,
    headers: headers,
    data: form,
  });
}



// WEBPACK FOOTER //
// ./src/utils/requestForSms.js